import { render, staticRenderFns } from "./LessonContent.vue?vue&type=template&id=e54aab06&scoped=true"
import script from "./LessonContent.vue?vue&type=script&lang=js"
export * from "./LessonContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54aab06",
  null
  
)

export default component.exports